// extracted by mini-css-extract-plugin
export default {"container":"ErrorBox_container__4ht4T"};